module.exports = __webpack_public_path__ + "static/no-god-but-god-c330d7689da45b9d736411e69d91477a.jpg";